import * as React from 'react';
import { EntityCombobox, type EntityLookupItem } from '../ui/EntityCombobox';
import { fetcher } from '../../lib/api-fetcher';

export interface ChitGroupPickerProps {
  value?: string;
  onChange: (value: string, item?: EntityLookupItem) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
}

export function ChitGroupPicker({
  value,
  onChange,
  placeholder = 'Select Chit Group...',
  disabled,
  className,
}: ChitGroupPickerProps) {
  const fetchGroups = React.useCallback(async (query: string): Promise<EntityLookupItem[]> => {
    try {
      // Query staff chit groups endpoint
      const res = await fetcher.get<{
        data?: Array<{
          id: string;
          schemeNumber?: string;
          groupCode?: string;
          displayName?: string;
          groupName?: string;
          schemeName?: string;
          name?: string;
          status?: string;
        }>;
      }>(
        `/staff/v1/chit-groups?limit=20${query ? `&q=${encodeURIComponent(query)}` : ''}`
      );
      const list = res?.data || [];
      return list.map((g) => ({
        id: g.id,
        code: g.schemeNumber || g.groupCode || 'GROUP',
        title: g.displayName || g.groupName || g.schemeName || g.name || 'Chit Group',
        badge: g.status,
      }));
      // allow-silent-catch: return empty list on search failure
    } catch {
      return [];
    }
  }, []);

  return (
    <EntityCombobox
      value={value}
      onChange={onChange}
      fetchItems={fetchGroups}
      placeholder={placeholder}
      searchPlaceholder="Search group by code or name..."
      disabled={disabled}
      className={className}
    />
  );
}
